import styled from 'styled-components';
import { tablet768, desktop1024 } from '@nubank/nuds-web/styles/breakpoints';

export const Section = styled.div`
  padding: 2.25rem 1.5rem;

  ${tablet768`
    padding: 5rem 2.5rem;
    display: flex;
    flex-direction: column-reverse;
  `}

  ${desktop1024`
    padding: 7rem 10rem;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  `}
`;

Section.displayName = 'Section';

export const ImageSection = styled.div`
  margin: 0 0.5rem 2rem;

  ${tablet768`
    margin: 0;
  `}

  ${desktop1024`
    width: 50%;
  `}
`;

ImageSection.displayName = 'ImageSection';

export const TextSection = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;

  ${desktop1024`
    text-align: left;
  `}
`;

TextSection.displayName = 'TextSection';
